module.exports = __webpack_public_path__ + "img/OTP_check_ic_confirm.62d7f22.svg";